<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                filterable
                v-model="search.appInfoId"
                clearable
                placeholder="投放应用"
            >
              <el-option
                  v-for="item in appList"
                  :key="item.appInfoId"
                  :label="item.appName"
                  :value="item.appInfoId"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="投放渠道"
            >
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="'['+item.channelTypeName+']'+item.name+'('+item.code+')'"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
<!--            :label="`${item.channelTypeName}-${item.account}`"-->
            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询
            </el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleClick('add')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="channelTypeName" label="渠道类型"></el-table-column>
            <el-table-column prop="fbContent" label="渠道名称" min-width="160">
              <template slot-scope="scope">
                <span>{{scope.row.channelName}}({{scope.row.channelCode}})</span>
              </template>
            </el-table-column>
            <el-table-column prop="appName" label="应用名称" min-width="160">
              <template slot-scope="scope">
                  <span>{{scope.row.appName}}({{scope.row.swid}})</span>
              </template>
            </el-table-column>
            <el-table-column prop="advertUid" label="创意ID" min-width="80">
            </el-table-column>
            <el-table-column prop="bizName" label="测评题" min-width="220">
            </el-table-column>
            <el-table-column prop="bizUid" label="标识" min-width="100">
            </el-table-column>
            <el-table-column prop="" label="抵达" min-width="120">
              <template slot-scope="scope">0</template>
            </el-table-column>
            <el-table-column prop="" label="提测" min-width="120">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="完题" min-width="120">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="支付" min-width="120">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="payPrice" label="支付价" min-width="100">
              <template slot-scope="scope">
                <span>$ {{scope.row.payPrice/100}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="成交额" min-width="120">
              <template slot-scope="scope">0.00</template>
            </el-table-column>
            <el-table-column prop="" label="客单价" min-width="120">
              <template slot-scope="scope">0.00</template>
            </el-table-column>
            <el-table-column prop="ctime" label="时间" min-width="180"></el-table-column>
            <el-table-column prop="ctime" label="状态" min-width="80">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    v-model="scope.row.advertStatus"
                    :active-value="1"
                    @change="handleSwitch(scope.row)"
                    :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="400">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    v-if="editShow"
                    @click="handleClick('edit', scope.row)"
                    type="success"
                    style="margin-bottom: 5px"
                    plain
                >修改
                </el-button
                >
                <el-button
                    size="mini"
                    v-if="sourceShow"
                    type="success"
                    style="margin-bottom: 5px"
                    plain
                >素材
                </el-button
                >
                <el-button
                    size="mini"
                    v-if="styleShow"
                    type="warning"
                    @click="configureHandleClick(scope.row)"
                    plain
                >样式
                </el-button
                >
                <el-button
                    v-if="linkShow"
                    size="mini"
                    @click="getLiteratureExtensionLink(scope.row)"
                    type="warning"
                    plain
                >投放链接
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    size="mini"
                    type="warning"
                    @click="handleDelete(scope.row)"
                    plain
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--编辑详情-->
    <el-dialog
        title="新增/编辑测评创意"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="850px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >
          <div  v-loading="loadings">
            <el-row>
              <el-col :span="12">
                <el-form-item class="item" label="投放渠道：" prop="channelAccountId">
                  <el-select
                      filterable
                      :disabled="clickType=='edit'"
                      v-model="params.channelAccountId"
                      @change="changChanne"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in channelList"
                        :key="item.channelAccountId"
                        :label="'['+item.channelTypeName+']'+item.name+'('+item.code+')'"
                        :value="item.channelAccountId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="item" label="关联应用：" prop="appInfoId">
                  <el-select
                      filterable
                      :disabled="clickType=='edit'"
                      v-model="params.appInfoId"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in appList"
                        :key="item.appInfoId"
                        :label="item.appName"
                        :value="item.appInfoId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="创意名称：" prop="name">
                  <el-input
                      clearable
                      placeholder="创意名称"
                      v-model="params.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="广告计划：" prop="appType">
                  <div>默认</div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="测评题：" prop="bizName">
                  <el-input
                      clearable
                      placeholder="测评题"
                      v-model="params.bizName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标识：">
                  <div @click="changShowTest">{{params.bizUid?params.bizUid:'请选择'}}</div>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="支付价：" prop="payPrice">
                  <el-input
                      clearable
                      placeholder="支付价"
                      v-model="params.payPrice"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="原价：" prop="rawPrice">
                  <el-input
                      clearable
                      placeholder="原价"
                      v-model="params.rawPrice"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="14">
                <el-form-item label="有偿说明：">
                  <el-input
                      clearable
                      placeholder="有偿说明"
                      v-model="params.feeDescr"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="推荐会员：">
                  <el-switch
                      v-model="params.recomVip"
                      :active-value="1"
                      :inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="答题次数：" prop="showAnswers">
                  <el-input
                      clearable
                      placeholder=" 答题次数"
                      v-model="params.showAnswers"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="14">-->
              <!--                <el-form-item label="标签：">-->
              <!--                  8 页专业报告，60 个精选题目，约 30 分钟-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-col :span="24">
                <el-form-item label="显示版权：">
                  <el-switch
                      v-model="params.copyrightStatus"
                      :active-value="1"
                      :inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
              <template v-if="params.copyrightStatus==1">
                <el-col :span="24">
                  <el-form-item label="版权信息：">
                    <el-input
                        clearable
                        @input="onInput()"
                        placeholder="版权信息"
                        v-model="params.copyrightName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="版权描述：">
                    <el-input
                        clearable
                        @input="onInput()"
                        placeholder="版权描述"
                        v-model="params.copyrightDescr"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
            <!-- 微信//app分开 -->
          </div>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
       <el-button size="medium" type="primary" @click="handleEdit">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 测评题推广链接 -->
    <el-dialog
        title="投放链接"
        :visible.sync="dialogVisibleLink"
        width="800px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-form label-width="80px" ref="linkForm">
        <div class="appraisal-center fonts">
          <div class="flex-box pub-line">
            <div class="fl1">
              <span>创意ID：</span>
              <span class="glay">{{ params.taid }}</span>
            </div>
            <div class="fl1">
              <span> 广告计划：</span>
              <span class="glay">默认</span>
            </div>
          </div>
          <div class="flex-box pub-line">
            <div class="fl1">
              <span>测评题：</span>
              <span class="glay">{{ params.bizName }}</span>
            </div>
            <div class="fl1">
              <span>标识：</span>
              <span class="glay">{{ params.bizUid}}</span>
            </div>
          </div>
          <div class="flex-box pub-line">
            <div class="fl1">
              <span>投放渠道：</span>
              <span class="glay">{{ params.channelName }}（{{params.channelCode}} ）</span>
            </div>
            <div class="fl1">
              <span>应用：</span>
              <span class="glay">{{ params.appName }}（{{params.swid}} ）</span>
            </div>
          </div>
        </div>

        <el-form-item label="链接：">
          <div
              style="margin-bottom: 10px;cursor: pointer"
              v-for="(items, index) in putUpLink"
              :key="index"
          >
            <div style="font-weight: 600">{{items.name}}</div>
            <div @click="copyLink(item.url)" v-for="(item,index) in items.urls" :key="index">
              <el-tag size="small" type="success">{{item.name}}</el-tag>
              <span style="margin: 0 10px">{{item.url}}</span>
              <el-tag  size="small">复制</el-tag>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 测评题数据 -->
    <el-dialog
        title="测评题列表"
        :visible.sync="alldataSourceVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="multipleTableTest"
              size="medium"
              :data="allTestTableData"
              border
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              @current-change="handleTarotSelectionChange"
          >
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="150" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

  </section>
</template>
<script>
import {
  PAGE_SIZE,
  COMPLIANT_TIMETYPE
} from "@/config";

import {formatMaxNum, formatMinNum, emptyShow} from "@utils/tools/index";

export default {
  data() {
    return {
      /* 函数 方法 */
      emptyShow, formatMaxNum, formatMinNum,
      /* 字段或数组 */
      PAGE_SIZE,
      COMPLIANT_TIMETYPE,
      channelList: [], //渠道类型list
      appList: [], //归属应用appid
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },

      tableData: [], //顶顶那列表

      loading: false,

      search: {
        // bizType:'exam'
      },

      searchShow: false,
      addShow: false,
      statusShow: true,
      editShow: false,
      sourceShow: false,
      styleShow: false,
      linkShow: false,
      deleteShow:false,

      dialogVisible: false,

      params: {
        copyrightStatus: 1,
        recomVip: 1,
        bizType: 'exam',
        copyrightName:'',
        copyrightDescr:''
      },

      rules: {
        name: [
          {required: true, message: "请填写创意名称", trigger: "blur"},
        ],
        appInfoId: [
          {required: true, message: "请选择关联应用", trigger: "change"},
        ],
        channelAccountId: [
          {required: true, message: "请选择投放渠道", trigger: "change"},
        ],
        bizUid: [
          {required: true, message: "请选择测评题"},
        ],
        payPrice: [
          {required: true, message: "请填写支付价", trigger: "blur"},
        ],
        rawPrice: [
          {required: true, message: "请填写原价", trigger: "blur"},
        ],
        showAnswers: [
          {required: true, message: "请填写答题次数", trigger: "blur"},
        ],
        bizName: [
          {required: true, message: "请填写测评题名称", trigger: "blur"}
        ]
      }, //表单验证提示

      allTestTableData: [],

      clickType: '',

      dialogVisibleLink:false,

      putUpLink:[],

      alldataSourceVisible:false,
      currentRow:null,

      loadings:false
    };
  },
  created() {
    this.maneyInfd();
    this.getAppList();
    this.getserviceList();
    this.queryTestTableData()
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisibleLink() {
      if (this.dialogVisibleLink == false) {
        this.params = {
          copyrightStatus: 1,
          recomVip: 1,
          bizType: 'exam'
        };
      }
    },
  },
  methods: {
    changShowTest(){
      if(this.clickType=='add'){
        this.alldataSourceVisible = true
      }
    },

    handleTarotSelectionChange(e){
      this.params.bizName = e.name
      this.params.bizId = e.examInfoId
      this.params.bizUid = e.examId
      this.alldataSourceVisible = false
    },

    copyLink(e_link) {
      let _this = this
      this.$copyText(e_link).then(function (e) {
        _this.$message.success('复制成功')
      }, function (e) {
        _this.$message.success('复制失败')
      })
    },
    //投放链接内容
    async getLiteratureExtensionLink(row){
      this.loading = true
      const {data: linkData} = await this.$get(`/advert/info/${row.advertId}`);
      if (linkData.result != 200) return;
      this.params = linkData.data;
      const {data: sceneskData} = await this.$get(`/advert/url/${row.advertId}`);
      if (sceneskData.result != 200) return;
      this.putUpLink = sceneskData.data;
      this.dialogVisibleLink = true;
      this.loading = false
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/advert/info/${row.advertId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.$message.success("删除成功!");
      });
    },
    // 配置
    configureHandleClick(e) {
      this.$router.push({
        name: "EVALUATION_CONFIG",
        query: {
          advertId: e.advertId,
        },
      });
    },

    async handleClick(mode,e){
      this.clickType = mode
      if(this.clickType=='add'){
          this.params = JSON.parse(JSON.stringify({
            copyrightStatus: 1,
            recomVip: 1,
            bizType: 'exam'
          }))
        this.dialogVisible = true
      }else if(this.clickType=='edit'){
        this.loading = true;
        const {data: resData} = await this.$get("/advert/info/" + e.advertId);
        this.loading = false;
        if (resData.result != 200) return;
        this.params = resData.data
        let numPay = ((this.params.payPrice) / 100).toFixed(2)
        let numRaw = ((this.params.rawPrice) / 100).toFixed(2)
        this.params.payPrice = parseInt(numPay);
        this.params.rawPrice = parseInt(numRaw);
        this.dialogVisible = true
      }
      // console.log(mode,e)
    },

    //编辑页面信息
    handleEdit() {
      let numPay = ((this.params.payPrice) * 100).toFixed(2)
      let numRaw = ((this.params.rawPrice) * 100).toFixed(2)
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if(!this.params.bizId){
           this.$message.error('请选择你当前创意的测评题')
          return;
        }
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.payPrice = parseInt(numPay);
          this.params.rawPrice = parseInt(numRaw);
          if (this.clickType == "add") {
            const {data: resData} = await this.$post(
                "/advert/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getserviceList();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = JSON.parse(JSON.stringify({
              copyrightStatus: 1,
              recomVip: 1,
              bizType: 'exam'
            }))
          }
          if (this.clickType == "edit") {
            const {data: resData} = await this.$put(
                "/advert/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;
            this.getserviceList();
            this.dialogVisible = false;
            this.params = JSON.parse(JSON.stringify({
              copyrightStatus: 1,
              recomVip: 1,
              bizType: 'exam'
            }))
            this.$message.success("修改成功!");
          }
        });
      });
    },

    async changTest(e) {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/info/" + e);
      this.loading = false;
      if (resData.result != 200) return;
      this.params.bizName = resData.data.name
      this.params.bizId = resData.data.examInfoId
    },

    changChanne(e) {
      this.loadings = true;
      this.$get("/channel/copyright/" + e).then(resData=>{
        this.loadings = false;
        // console.log(resData.dta)
        if (resData.data.result != 200){
          return;
        } else {
          if( resData.data){
            this.params.copyrightName =  resData.data.data.copyrightName?JSON.parse(JSON.stringify(resData.data.data.copyrightName)):JSON.parse(JSON.stringify(''))
            this.params.copyrightDescr = resData.data.data.copyrightDescr?JSON.parse(JSON.stringify(resData.data.data.copyrightDescr)):JSON.parse(JSON.stringify(''))
          }
        }
      })
      // const {data: resData} = await this.$get("/channel/copyright/" + e);
    },
    onInput(){
      this.$forceUpdate();
    },

    //获取测评题
    async queryTestTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/list?styleType=cpzy&paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.allTestTableData = resData.data
      // this.alldataSourceVisible = true
    },
    //设置权限
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'launch:evalua:query') {
            this.searchShow = true
          }
          if (item.code == 'launch:evalua:add') {
            this.addShow = true
          }
          if (item.code == 'launch:evalua:status') {
            this.statusShow = false
          }
          if (item.code == 'launch:evalua:edit') {
            this.editShow = true
          }
          if (item.code == 'launch:evalua:source') {
            this.sourceShow = true
          }
          if (item.code == 'launch:evalua:style') {
            this.styleShow = true
          }
          if (item.code == "launch:evalua:link") {
            this.linkShow = true
          }
          if (item.code == "launch:evalua:delete") {
            this.deleteShow = true
          }
          // CreativeStyle
        })
      }
    },
    //获取归属应用
    async getAppList() {
      const {data: orgData} = await this.$get(`/app/list?paging=false`);
      this.appList = orgData.data;
    },

    async maneyInfd() {
      this.loading = true;
      const {data: resData} = await this.$get("/console/info2");
      this.loading = false;
      if (resData.result != 200) return;
      this.userInfo = resData.data.info;
      this.getChannelList()
    },
    //获取渠道 账号 类型
    async getChannelList() {
      const {data: orgData} = await this.$get(`/advertiser/channel/tf/list?advertiserId=` + this.userInfo.advertiserId);
      this.channelList = orgData.data;
    },
    //查询
    SearchServiceList() {
      this.page.pageNo = 1
      delete this.page['count']
      this.getserviceList()
    },
    //创意列表
    async getserviceList() {
      this.loading = true;
      const {data: res} = await this.$get(
          `/advert/list`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    //switch状态改变 --接口 修改岗位状态
    handleSwitch(e) {
      this.$put(`/advert/info/status/${e.advertId}`);
      this.$message({
        message: '操作成功',
        type: "success",
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 800px;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-bottom: 30px;
}

.congT_dis {
  display: flex;
  align-items: center;
}

</style>
